import { useEffect } from "react";
import { useEditor, useValue } from "tldraw";

import { inkForNextShape } from "./inkForNextShape";
import { markDrawRegion, unmarkDrawRegion } from "./shield";

/**
 * Marks a tldraw canvas as a draw region while its draw tool is active, in
 * the next stroke's colour. Render inside <Tldraw>. The mark goes on the
 * canvas, not the container, so the toolbar keeps the real cursor.
 */
export function TldrawDrawToolRegion() {
  const editor = useEditor();
  const isDrawTool = useValue(
    "draw tool active",
    () => editor.getCurrentToolId() === "draw",
    [editor],
  );
  const ink = useValue("next stroke ink", () => inkForNextShape(editor), [
    editor,
  ]);

  useEffect(() => {
    if (!isDrawTool) return;
    const canvas =
      editor.getContainer()?.querySelector<HTMLElement>(".tl-canvas") ?? null;
    if (!canvas) return;
    markDrawRegion(canvas, ink);
    return () => unmarkDrawRegion(canvas);
  }, [editor, isDrawTool, ink]);

  return null;
}
